import { useChannel, useEvent } from '@harelpls/use-pusher';
import { useApolloClient } from '@apollo/client';
import { useToast } from 'components/layout/Toast';
import { loader } from 'graphql.macro';
import { personName } from '@onwardcare/core';

const DASHBOARD_QUERY = loader('../../data/queries/DashboardQuery.graphql');

const RealtimeHandler = ({ account }) => {
  const apolloClient = useApolloClient();
  const toast = useToast();

  const channel = useChannel('account_' + account.id);
  useEvent(channel, 'rideCompleted', data => handleRideCompleted(data.id));
  useEvent(channel, 'rideNoShow', data => handleRideNoShow(data.id));
  useEvent(channel, 'rideStarted', data => handleRideStarted(data.id));

  const handleRideCompleted = rideId => {
    const data = apolloClient.readQuery({ query: DASHBOARD_QUERY });
    if (!data || !data.upcomingRides) {
      return;
    }

    const { upcomingRides } = data;
    const ride = upcomingRides.find(r => r.id.toString() === rideId.toString());
    if (ride) {
      const rideType = ride.rideType === 'delivery' ? 'delivery' : 'ride';
      const message = `${personName(ride.rider)}'s ${rideType} just completed.`;

      const rideIndex = upcomingRides.findIndex(
        r => r.id.toString() === rideId.toString(),
      );
      const updatedRides = [
        ...upcomingRides.slice(0, rideIndex),
        ...upcomingRides.slice(rideIndex + 1),
      ];

      apolloClient.writeQuery({
        query: DASHBOARD_QUERY,
        data: {
          upcomingRides: updatedRides,
        },
      });
      toast.showMessage(message);
    }
  };

  const handleRideNoShow = rideId => {
    const data = apolloClient.readQuery({ query: DASHBOARD_QUERY });
    if (!data || !data.upcomingRides) {
      return;
    }

    const { upcomingRides } = data;
    const ride = upcomingRides.find(r => r.id.toString() === rideId.toString());
    if (ride) {
      const rideType = ride.rideType === 'delivery' ? 'delivery' : 'ride';
      const message = `${personName(
        ride.rider,
      )}'s ${rideType} was marked as a no show.`;

      const rideIndex = upcomingRides.findIndex(
        r => r.id.toString() === rideId.toString(),
      );
      const updatedRides = [
        ...upcomingRides.slice(0, rideIndex),
        ...upcomingRides.slice(rideIndex + 1),
      ];

      apolloClient.writeQuery({
        query: DASHBOARD_QUERY,
        data: {
          upcomingRides: updatedRides,
        },
      });
      toast.showMessage(message);
    }
  };

  const handleRideStarted = rideId => {
    const data = apolloClient.readQuery({ query: DASHBOARD_QUERY });
    if (!data || !data.upcomingRides) {
      return;
    }

    const { upcomingRides } = data;
    const rideIndex = upcomingRides.findIndex(
      r => r.id.toString() === rideId.toString(),
    );
    if (rideIndex >= 0) {
      const ride = upcomingRides[rideIndex];
      const rideType = ride.rideType === 'delivery' ? 'delivery' : 'ride';
      const message = `${personName(ride.rider)}'s ${rideType} just started.`;

      const updatedRides = upcomingRides.map((item, index) => {
        if (index !== rideIndex) return item;

        return { ...item, status: 'inprogress' };
      });

      apolloClient.writeQuery({
        query: DASHBOARD_QUERY,
        data: {
          upcomingRides: updatedRides,
        },
      });

      toast.showMessage(message);
    }
  };

  return null;
};

export default RealtimeHandler;
